import React from 'react';
import { withTheme, useIsMobile } from '@elliemae/ds-system';
import ChevronDown from '@elliemae/ds-icons/ChevronDown';
import ChevronRight from '@elliemae/ds-icons/ChevronRight';
import DSButton from '@elliemae/ds-button';
import DSAccordionHeaderActions from './DSAccordionHeaderActions.js';
import DSAccordionHeader$1 from './DSAccordionHeaderTitle.js';
import { accordionButton, accordionTitle } from './blocks.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-truncated-tooltip-text';
import '@elliemae/ds-classnames';

var DSAccordionHeader = withTheme(function (_ref) {
  var title = _ref.title,
      secondaryTitle = _ref.secondaryTitle,
      customActions = _ref.customActions,
      idx = _ref.idx,
      icon = _ref.icon,
      selected = _ref.selected,
      setTabRef = _ref.setTabRef,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown;
  var mobile = useIsMobile();
  var hasSecondaryTitle = Boolean(secondaryTitle);
  var selectedClass = selected ? 'selected' : '';
  var labelClass = hasSecondaryTitle ? 'secondary-title' : '';
  var IconMobile = selected ? ChevronDown : ChevronRight;
  return /*#__PURE__*/React.createElement(DSButton, {
    "aria-controls": "sec".concat(idx),
    "aria-expanded": selected,
    "aria-label": title,
    as: "div",
    buttonType: "secondary",
    className: "".concat(accordionButton, " ").concat(selectedClass, " ").concat(hasSecondaryTitle ? 'with-secondary-title' : ''),
    "data-testid": "ds-accordion_item-header",
    innerRef: setTabRef,
    labelText: /*#__PURE__*/React.createElement("div", {
      className: "".concat(accordionTitle, " ").concat(selectedClass, " ").concat(labelClass)
    }, !mobile && icon, /*#__PURE__*/React.createElement(DSAccordionHeader$1, {
      idx: idx,
      secondaryTitle: secondaryTitle,
      title: title
    }), !mobile && /*#__PURE__*/React.createElement(DSAccordionHeaderActions, {
      customActions: customActions
    }), mobile && /*#__PURE__*/React.createElement(IconMobile, null)),
    onClick: onClick,
    onKeyDown: onKeyDown
  });
});

export default DSAccordionHeader;
//# sourceMappingURL=DSAccordionHeader.js.map
